export const DocumentUploadForm = {
  model: 'Document',
  format: [
    {
      widths: 'equal',
      fields: {
        file: {
          required: true,
          type: 'file',
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        box_item: {
          required: true,
          label: 'Document Type',
          type: 'dropdown search',
          url: '/main/box-items/',
          title_fields: ['box_item_type'],
          description_fields: [],
        },
        visibility: {
          type: 'dropdown',
          visibleto: ['admin'],
        },
      },
    },
  ],
}
